import React from "react"
import Seo from "../components/seo"
import Header from "../components/header"
import Footer from "../components/footer"
import Section from "../components/section"
import BackgroundOverlay from "../components/backgroundOverlay"
import mainLayoutStyle from '../styles/mainLayout.module.scss'
import mainThemeStyle from '../styles/mainTheme.module.scss'
import cx from 'classnames'


let interval;
let timeout;
class ScrollEverywhereFix extends React.Component {
    componentDidMount() {
        // SimpleBar.options.scrollbarMaxSize = 20;
        let scrollBox = document.querySelector(".simplebar-content-wrapper");

        let hover = true;
        scrollBox.addEventListener("mouseenter", event => {
            hover = true;
        })
        scrollBox.addEventListener("mouseleave", event => {
            hover = false;
        })
        if (scrollBox) {
            hover = false;
            window.addEventListener("mousewheel", event => {
                if (!hover) {
                    scrollBox.scrollTop += 0.3 * event.deltaY
                }
            }, {passive: true})
        }
    }
    render() {
        return null;
    }
}
class MobileLayoutHeightFix extends React.Component {
    componentDidMount() {
        let resizes = document.querySelectorAll("body, html");
        
        const onResizeHandler = event => {
            resizes.forEach(el => {
                el.setAttribute("style", `height: ${window.innerHeight}px`)
            })
        }
        window.addEventListener("touchstart", () => {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                interval = setInterval(onResizeHandler, 50);
            }, 10);
            
            
        }, {passive: true});
        window.addEventListener("touched", () => {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                clearInterval(interval);
            }, 10);
        }, {passive: true});
        onResizeHandler();
        
    }
    render() {
        return null;
    }
}



const MainLayout = (data) => {
    return (
        <main className={cx(mainLayoutStyle.BASE, mainThemeStyle.BASE)} overlay={data.props.pageContext.overlay.color}>
            <Seo wpMeta={data.props.pageContext.siteMeta[0].node.allSettings} pageMeta={data.props.pageContext.pageTitle}></Seo>
            <BackgroundOverlay background={data.props.pageContext.background} overlay={data.props.pageContext.overlay}/>
            <Header menu={data.props&&data.props.pageContext.header[0].node.menuItems.nodes} logo={""} />
                <Section dynamicContent={data.props&&data.props.data.page.content} pageTitle={data.props.pageContext.pageTitle} contact={data.props.pageContext.contactInfo}/>
            <Footer menu={data.props&&data.props.pageContext.header[1].node.menuItems.nodes} contact={data.props.pageContext.contactInfo}/>
            <MobileLayoutHeightFix/>
            <ScrollEverywhereFix/>
        </main>
        
    )
}
export default MainLayout
